import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';

import {interventionPropTypes} from '../../../utils/propTypes';

import ProjectTreeRow from './ProjectTreeRow';

import {arrangeInterventionTreeForDisplay} from './utils';

const lignSeparator =
    <div className='d-flex justify-content-center'>
      <div
        style={{
          borderBottom: '1px solid rgba(150, 150, 150, 0.3)',
          paddingBottom: 40,
          marginBottom: 40,
          width: '98%'
        }}
      />
    </div>;

export function ProjectTree(props) {
  const [clientInterventions, projectManagerInterventions, otherInterventions] = arrangeInterventionTreeForDisplay(props.interventions);

  const hasClientInterventions = !isEmpty(clientInterventions);
  const hasProjectManagerInterventions = !isEmpty(projectManagerInterventions);
  const hasOtherInterventions = !isEmpty(otherInterventions);

  const arrangedInterventions = [clientInterventions, projectManagerInterventions, otherInterventions].flat();
  const myInterventionInTree = arrangedInterventions.find(intervention => intervention.interventionId === props.myIntervention.interventionId);

  const displayInterventionsTree = (keyPrefix, interventions) => (
    interventions.map(intervention => (
      <ProjectTreeRow
        key={`${keyPrefix}${intervention.interventionId}`}
        data-id={`${keyPrefix}${intervention.interventionId}`}
        intervention={intervention}
        myIntervention={myInterventionInTree}
        onResendInvitation={props.onResendInvitation}
        onRemoveOrganisation={props.onRemoveOrganisation}
        onSubmitEndOrganisation={props.onSubmitEndOrganisation}
        onCancelIntervention={props.onCancelIntervention}
        onRefreshProjectData={props.onRefresh}
      />
    )));

  return (
    <div className="card">
      <div className="card-header mb-5">
        <div className="card-title">
          <strong><Translate value={'project.tree.title'}/></strong>
        </div>
      </div>

      {hasClientInterventions && (
        <>
          <h2><Translate value={'project.tree.clients'}/></h2>
          {displayInterventionsTree('client-tree-row-', clientInterventions)}
          {(hasProjectManagerInterventions || hasOtherInterventions) && lignSeparator}
        </>
      )}

      {hasProjectManagerInterventions && (
        <>
          <h2><Translate value={'project.tree.projectManagers'}/></h2>
          {displayInterventionsTree('project-manager-tree-row-', projectManagerInterventions)}
          {hasOtherInterventions && lignSeparator}
        </>
      )}

      {hasOtherInterventions && (
        <>
          <h2><Translate value={'project.tree.supplyChain'}/></h2>
          {displayInterventionsTree('project-tree-row-', otherInterventions)}
        </>
      )}
    </div>
  );
}

ProjectTree.propTypes = {
  project: PropTypes.object.isRequired,
  myIntervention: interventionPropTypes().isRequired,
  interventions: PropTypes.arrayOf(interventionPropTypes()).isRequired,
  onSubmitEndOrganisation: PropTypes.func.isRequired,
  onResendInvitation: PropTypes.func.isRequired,
  onRemoveOrganisation: PropTypes.func.isRequired,
  onCancelIntervention: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
};

export default ProjectTree;
